<script setup>
defineProps({
  steps: { type: Array, required: true },
  current: { type: Number, required: true },
  hasErrors: { type: Boolean, default: false },
});

function stateOf(idx, current, hasErrors) {
  const stepNum = idx + 1;
  if (stepNum < current) return 'completed';
  if (stepNum === current) return hasErrors && stepNum === 1 ? 'error' : 'active';
  return 'pending';
}
</script>

<template>
  <aside class="sz-import-sidebar">
    <ul>
      <li
        v-for="(step, idx) in steps"
        :key="step.key"
        :class="['sz-step', `sz-step-${stateOf(idx, current, hasErrors)}`]"
      >
        <span class="sz-step-rail">
          <span class="sz-step-marker">
            <svg
              v-if="stateOf(idx, current, hasErrors) === 'completed'"
              width="12" height="12" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="3.5"
              stroke-linecap="round" stroke-linejoin="round"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </span>
          <span v-if="idx < steps.length - 1" class="sz-step-line" />
        </span>
        <div class="sz-step-text">
          <div class="sz-step-title">
            <span v-if="step.required" class="sz-step-required">*</span>
            <span class="sz-step-title-text">{{ step.title }}</span>
          </div>
          <div class="sz-step-subtitle">{{ step.subtitle }}</div>
        </div>
      </li>
    </ul>
  </aside>
</template>

<style lang="scss" scoped>
.sz-import-sidebar {
  background: #fafafa;
  border-right: 1px solid rgba(0,0,0,0.06);
  padding: 22px 18px;
  overflow-y: auto;
}

ul { list-style: none; padding: 0; margin: 0; }

.sz-step {
  display: grid;
  grid-template-columns: 24px 1fr;
  gap: 12px;
  padding: 4px 0 16px;
}
.sz-step:last-child { padding-bottom: 0; }

.sz-step-rail {
  display: flex; flex-direction: column; align-items: center;
  gap: 4px;
}
.sz-step-marker {
  width: 18px; height: 18px;
  border: 1.5px solid #18181b;
  border-radius: 999px;
  display: inline-flex; align-items: center; justify-content: center;
  background: transparent;
  color: #16a34a;
  flex-shrink: 0;
  transition: border-color 0.15s, background 0.15s;
}
.sz-step-line {
  flex: 1;
  width: 1.5px;
  min-height: 28px;
  background: #18181b;
  margin: 4px 0;
}
.sz-step-completed .sz-step-marker {
  background: #16a34a; border-color: #16a34a; color: #ffffff;
}
.sz-step-completed .sz-step-line { background: #16a34a; }
.sz-step-active .sz-step-marker { border-color: #16a34a; }
.sz-step-active .sz-step-line   { background: #16a34a; }
.sz-step-error .sz-step-marker  { border-color: #dc2626; }
.sz-step-error .sz-step-line    { background: #dc2626; }








.sz-step-text { padding-top: 0; }
.sz-step-title {
  font-size: 14px; font-weight: 600;
  display: flex; gap: 4px; align-items: center;
  color: #18181b;
}


.sz-step-active  .sz-step-title-text { color: #16a34a; }
.sz-step-error   .sz-step-title-text { color: #dc2626; }
.sz-step-required { color: #dc2626; font-weight: 600; }

.sz-step-subtitle {
  font-size: 13px; color: #71717a; margin-top: 2px; line-height: 1.4;
}

</style>
